/* eslint-disable security/detect-object-injection */
/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState, useMemo } from "react"
import { motion } from 'framer-motion'
import BloodGlouseVitalList from "./BloodGlouseVital"
import BloodGlouseVitalTopBar from "./BloodGlouseVital/Components/Topbar"
import { useLocation, useSearchParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import Debounce from "../../../../CommonMethods/Debounce"
import { handleAddFilterValues, resetFilterState } from "../../../../redux/systemConfigSlice"
import { useExportDeviceVitalReadingListMutation, useVitalReadingListQuery } from "../../../../slices/patientSlice"
import moment from "moment"
import HelpGuideModal from "../../../../components/HelpGuideModal"
import { useGetHelpGuideProviderQuery } from '../../../../slices/patientSlice'


export default function HistoricalData({ setHistoricalDataLoading }) {
    const [vitalTabName, setVitalTabName] = useState('all')
    const location = useLocation()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideProviderQuery(queryParamsorg, {
        skip: !triggerApiCall, // Skip the query until the trigger is set to true
    });

    const [searchParams, setSearchParams] = useSearchParams({ 'filter': 'true' });
    
    // Memoize queryParams to prevent unnecessary recalculations and API calls
    const queryParams = useMemo(() => {
        let params = new URLSearchParams(searchParams?.toString())
        params?.delete('tabname')
        params?.delete('view')
        return params?.toString();
    }, [searchParams]);
    const querySkip = searchParams.size < 8;
    const { data, isFetching, status } = useVitalReadingListQuery(queryParams, { skip: querySkip, refetchOnMountOrArgChange: false })
    const [suggestions, setSuggestions] = useState("")
    const dispatch = useDispatch()
    const [exportDeviceVitalDetails] = useExportDeviceVitalReadingListMutation()

    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const initialState = {
        "filter_start_date": '',
        "filter_end_date": '',
    }
    const [filterValues, setFilterValues] = useState(initialState)
    const [isFilterOpen, setIsFilterOpen] = useState(false);

    /**
    * The function `handleSearchParams` updates the search parameters by setting the value of a
    * specific key and value, and then updating the search parameters state.
    */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.last_page = null
        params.last_id = null
        params.last_sort_value = null
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }

    useEffect(() => {
        // Early return if all required params are already set to prevent unnecessary runs
        const requiredParams = ['limit', 'page_number', 'reading_type', 'filter', 'patient_id', 'last_id', 'last_page', 'last_sort_value', 'sort'];
        const allParamsSet = requiredParams.every(param => {
            if (param === 'patient_id') {
                return searchParams.get('patient_id') || !location.pathname.split('/')?.[4];
            }
            return searchParams.get(param) !== null && searchParams.get(param) !== undefined && searchParams.get(param) !== '';
        });
        
        if (allParamsSet && searchParams.get('sort') && searchParams.get('sort') !== '_id+asc' && searchParams.get('sort') !== '_id%2Basc' && searchParams.get('sort') !== '_id+desc' && searchParams.get('sort') !== '_id%2Bdesc') {
            setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '');
            return;
        }

        // Collect all parameter changes first, then update once to avoid multiple re-renders
        let params = Object.fromEntries(searchParams);
        let paramsChanged = false;

        if (!searchParams.get('limit')) {
            params.limit = '15';
            paramsChanged = true;
        }
        if (!searchParams.get('page_number')) {
            params.page_number = '1';
            paramsChanged = true;
        }
        if (!searchParams.get('reading_type')) {
            params.reading_type = vitalTabName;
            paramsChanged = true;
        }
        if (!searchParams.get('filter')) {
            params.filter = 'true';
            paramsChanged = true;
        }
        if (!searchParams.get('patient_id')) {
            const patientId = location.pathname.split('/')?.[4];
            if (patientId) {
                params.patient_id = patientId;
                paramsChanged = true;
            }
        }
        if (!searchParams.get('last_id')) {
            params.last_id = null;
            paramsChanged = true;
        }
        if (!searchParams.get('last_page')) {
            params.last_page = null;
            paramsChanged = true;
        }
        if (!searchParams.get('last_sort_value')) {
            params.last_sort_value = null;
            paramsChanged = true;
        }
        // Update default sort from _id+asc to measurement_date_time+desc
        const currentSort = searchParams.get('sort');
        if (!currentSort || currentSort === '_id+asc' || currentSort === '_id%2Basc' || currentSort === '_id+desc' || currentSort === '_id%2Bdesc') {
            params.sort = 'measurement_date_time+desc';
            paramsChanged = true;
        }

        // Reset pagination params when updating other params
        if (paramsChanged) {
            params.page_number = '1';
            params.last_page = null;
            params.last_id = null;
            params.last_sort_value = null;
        }

        // Only update searchParams once if any changes were made
        // Compare the stringified versions to avoid unnecessary updates
        if (paramsChanged) {
            const currentParamsString = JSON.stringify(Object.fromEntries(searchParams));
            const newParamsString = JSON.stringify(params);
            if (currentParamsString !== newParamsString) {
                setSearchParams(params);
            }
        }

        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location.pathname, vitalTabName]);

    useEffect(() => {
        if (userType === 'monitor-user') {
            setQueryParamsorg('type=provider-historical-data');
        } else {
            setQueryParamsorg('type=provider-historical-data');
        }
    }, [userType]);

    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true); // Allow the query to run
        }
    }, [queryParamsorg]);

    useEffect(() => {
        if (setHistoricalDataLoading) {
            setHistoricalDataLoading(isFetching);
        }
    }, [isFetching, setHistoricalDataLoading]);

    useEffect(() => {

        if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            dispatch(resetFilterState())
        }
    }, [searchParams])

    const handleChange = (val) => {
        handleSearchParams('search', val)

    };
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );

    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        const start_date = moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date = moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date": filterValues.filter_start_date,
            "filter_end_date": filterValues.filter_end_date,

        }))
        if (type) {
            params.page_number = 1
            params['last_id'] = null
            params['last_page'] = null
            if (filterValues?.filter_start_date !== "") { params["start_date"] = start_date }
            if (filterValues?.filter_end_date !== "") { (params["end_date"] = end_date) }
            setSearchParams({ ...params })
        }
        else {
            params.start_date && delete params.start_date
            params.end_date && delete params.end_date
            setSearchParams({ ...params })
        }
    }

    const handleTabChange = (tabName) => {
        handleSearchParams('reading_type', tabName)
        let params = Object.fromEntries(searchParams)
        params?.start_date && delete params?.start_date
        params?.end_date && delete params?.end_date
        params["page_number"] = 1
        params.last_page = null
        params.last_id = null
        params.last_sort_value = null
        params['reading_type'] = tabName
        params["limit"] = 15
        params.sort = 'measurement_date_time+desc' // Set default sort
        setSearchParams(params)
        setVitalTabName(tabName)
        setIsFilterOpen(false)

    }

    useEffect(() => {
        if (searchParams.get('reading_type')) {
            setVitalTabName(searchParams.get('reading_type'))
        }
    }, [])

    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {

        setIsSafari(/^((?!chrome|firefox|android).)*safari/i.test(navigator.userAgent));
    }, []);

    return (
        <>
            <div id={"patient_main_div"} className='bg-[#F9F3F5] pt-6 h-full w-full overflow-x-hidden'>
                <div className='bg-white rounded-lg p-6'>
                    <motion.div
                        className="mt-1"
                        animate={{ x: 0 }}
                        initial={{ x: -10 }}
                        transition={{ duration: 0.5 }}
                    >
                        <div className='bg-white'>
                            <div className="flex items-center min-w-fit mb-4">
                                <h2 className="text-2xl font-semibold text-[#000000] ">Device Reading History</h2>
                                <span onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                </span>

                            </div>

                            <div className="flex justify-between items-center h-12">
                                <div className='mt-1 flex justify-between items-center w-full'>
                                    <div className={`flex justify-between ${isSafari ? 'pb-4' : 'pb-2'} overflow-x-auto overflow-y-hidden ${isSafari ? 'scrollbar_purple' : 'scrollBar-hidden'} border-b border-[#E7CBD2] w-full xl:mr-6`}>
                                        <button data-testid={"allvitals_tab"} onClick={() => { handleTabChange('all') }} className={`px-2.5 pt-2.5 min-w-fit text-base font-semibold ${vitalTabName === 'all' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'all' ? 'patient_tab' : ''}`}>
                                            All
                                        </button>
                                        <button id={'bloodGlouse_tab'} data-testid={'bloodGlouse_tab'} onClick={() => { handleTabChange('blood_glucose') }} className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${vitalTabName === 'blood_glucose' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'blood_glucose' ? 'patient_tab' : ''}`}>
                                            Blood Glucose
                                        </button>
                                        <button data-testid="bloodPressure_tab" id={'bloodPressure_tab'} onClick={() => { handleTabChange('blood_pressure') }} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${vitalTabName === 'blood_pressure' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'blood_pressure' ? 'patient_tab' : ''}`}>
                                            Blood Pressure
                                        </button>
                                        <button data-testid={'spo2_tab'} id={'spo2_tab'} onClick={() => { handleTabChange('spo2') }} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${vitalTabName === 'spo2' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'spo2' ? 'patient_tab' : ''}`}>
                                            SPO2
                                        </button>
                                        <button data-testid={'temprature_tab'} id={'temprature_tab'} onClick={() => { handleTabChange('temperature') }} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${vitalTabName === 'temperature' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'temperature' ? 'patient_tab' : ''}`}>
                                            Temperature
                                        </button>
                                        <button id={'pulse_tab'} data-testid={'pulse_tab'} onClick={() => { handleTabChange('pulse') }} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${vitalTabName === 'pulse' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'pulse' ? 'patient_tab' : ''}`}>
                                            Pulse
                                        </button>
                                        <button id={'weight_tab'} data-testid={'weight_tab'} onClick={() => { handleTabChange('weight') }} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${vitalTabName === 'weight' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${vitalTabName === 'weight' ? 'patient_tab' : ''}`}>
                                            Weight
                                        </button>
                                    </div>
                                    <BloodGlouseVitalTopBar
                                        SearchInput={((data?.historical_reading?.length === 0 && suggestions === "") || data === undefined) ? false : true}
                                        ApplyFilter={(searchParams.get("start_date") === null && searchParams.get("end_date") === null && (data?.historical_reading?.length === 0 || data === undefined)) ? false : true}
                                        suggestions={suggestions}
                                        setSuggestions={setSuggestions}
                                        handleApplyFilter={handleApplyFilter}
                                        optimizedFn={optimizedFn}
                                        data={data}
                                        exportCols={vitalTabName === 'all' ? ['Vital Type', 'Alert Type', 'Timestamp', 'Reading', 'Reading Details', 'Threshold', 'Device ID'] : ['Alert Type', 'Timestamp', 'Reading', 'Reading Details', 'Threshold', 'Device ID']}
                                        filterValues={filterValues}
                                        setFilterValues={setFilterValues}
                                        isColumnSelect={isColumnSelect}
                                        setIsColumnSelect={setIsColumnSelect}
                                        initialState={initialState}
                                        username={searchParams.get("target_user_name")}
                                        exportVitalDetails={exportDeviceVitalDetails}
                                        vitalTabName={vitalTabName}
                                        isFilterOpen={isFilterOpen}
                                        setIsFilterOpen={setIsFilterOpen}
                                    />
                                </div>
                            </div>
                            {(vitalTabName === "blood_glucose" || vitalTabName === 'temperature' || vitalTabName === 'weight' || vitalTabName === 'all' || vitalTabName === "blood_pressure" || vitalTabName === 'spo2' || vitalTabName === 'pulse') && <BloodGlouseVitalList
                                data={data}
                                isFetching={isFetching}
                                status={status}
                                searchParams={searchParams}
                                setSearchParams={setSearchParams}
                                filterValues={filterValues}
                                setFilterValues={setFilterValues}
                                suggestions={suggestions}
                                vitalTabName={vitalTabName?.split('_').map(word => word?.charAt(0)?.toUpperCase() + word.slice(1))?.join(' ')}
                                setSuggestions={setSuggestions}
                                handleSearchParams={handleSearchParams}
                                isColumnSelect={isColumnSelect}
                            />}

                        </div>
                        {(helpGuideModel && helpguidestatus === "fulfilled") &&
                            <HelpGuideModal
                                setHelpGuideModel={setHelpGuideModel}
                                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                            />
                        }

                    </motion.div>
                </div>


            </div>
        </>
    )
}